
import { Vue, Component, Watch } from "vue-property-decorator";
@Component({
  name: "goTop"
})
export default class GoTop extends Vue {
  scrollTop: number = 0;
  goTopShow: boolean = false;
  handleScroll() {
    this.scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    if (this.scrollTop > 500) {
      this.goTopShow = true;
    }
  }
  goTop() {
    let timer: number = 0,
      _that = this;
    cancelAnimationFrame(timer);
    timer = requestAnimationFrame(function fn() {
      if (_that.scrollTop > 0) {
        _that.scrollTop -= 500;
        document.body.scrollTop = document.documentElement.scrollTop =
          _that.scrollTop;
        timer = requestAnimationFrame(fn);
      } else {
        cancelAnimationFrame(timer);
        _that.goTopShow = false;
      }
    });
  }
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  }
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
}
